import styled from "styled-components/native";
import { DefaultTheme } from "styled-components/native";

const BadgeDot = ({ isDesktop }: any) => {
  return (
    <>
      <OuterCircle isDesktop={isDesktop} />
      <InnerCircle isDesktop={isDesktop} />
    </>
  );
};

const OuterCircle = styled.View<{
  isDesktop?: boolean;
}>`
  top: ${({ isDesktop }: { isDesktop?: boolean }) =>
    isDesktop ? "1.4px" : "5.5px"};
  right: 0;
  position: absolute;
  width: ${({ isDesktop }: { isDesktop?: boolean }) =>
    isDesktop ? "10px" : "11px"};
  height: ${({ isDesktop }: { isDesktop?: boolean }) =>
    isDesktop ? "10px" : "11px"};
  border-radius: 50px;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-01"]};
`;

const InnerCircle = styled.View<{
  isDesktop?: boolean;
}>`
  top: ${({ isDesktop }: { isDesktop?: boolean }) =>
    isDesktop ? "1.8px" : "6px"};
  right: ${({ isDesktop }: { isDesktop?: boolean }) =>
    isDesktop ? "0.5px" : "0.5px"};
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50px;
  background-color: ${({ theme }: { theme: DefaultTheme }) =>
    theme["error-01"]};
`;

export default BadgeDot;
